import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InvoiceNoteBus } from "./v_InvoiceNoteBus";
import { CommonValues } from "../static/CommonValues";

 export class InvoiceNoteBus extends BaseBus
 {
     constructor(busObj: BaseBus = null) {
         super(busObj);
         if (busObj != null) {
             this.invoiceNotePersonId = busObj["invoiceNotePersonId"];
         }
         if (CommonFunctions.hasValue(this.insertDt)) {
             this.insertDt = new Date(this.insertDt);
         }
         if (CommonFunctions.hasValue(this.updateDt)) {
             this.updateDt = new Date(this.updateDt);
         }
     }

     CID(): any {
         return this.invoiceNoteId;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
         if (!CommonFunctions.hasGuidValue(this.invoiceNotePersonId) && this.invoiceNotePersonId != CommonValues.Guid_Empty) {
             this.invoiceNotePersonId = personId;
         }
     }
     setParentId(id: any) {
         this.invoiceId = id;
     }
     get usesOrderValue(): boolean {
         return true;
     }
     get orderValue(): number {
         return this.sortOrder;
     }
     set orderValue(value: number) {
         this.sortOrder = value;;
     }
     setAdditionalFromView(data: v_InvoiceNoteBus) {
         this.invoiceNotes1 = data.invoiceNotes;
     }
     setBeforeSave() {
         this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
         this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
     }
     invoiceNoteId: string;
        invoiceId: string;
        invoiceNotePersonId: string;
        isPrintable: boolean;
        invoiceNotes1: string;
        insertDt: Date;
        insertUserId: string;
        updateDt: Date;
        updateUserId: string;
     sortOrder: number;

     public static getDataObjsFromViewObjs(dataObjs: v_InvoiceNoteBus[]) : InvoiceNoteBus[] {
         let arr: InvoiceNoteBus[] = [];
         if (CommonFunctions.hasArrayElementValue(dataObjs)) {
             for (let i = 0; i < dataObjs.length; i++) {
                 let busObj: InvoiceNoteBus = new InvoiceNoteBus(dataObjs[i]);
                 busObj.setAdditionalFromView(dataObjs[i]);
                 busObj.setBeforeSave();
                 arr.push(busObj);   
             }
         }
         return arr;
     }
 }
